import cn from 'classnames';
import React, {FC, PropsWithChildren} from 'react';
import {Icon} from '../Icon';

interface Props {
	gray?: boolean;
	onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export type AddButtonProps = PropsWithChildren<Props>;

const AddButton: FC<AddButtonProps> = ({gray = false, onClick, children}) => (
	<div
		className={cn('flex items-center w-full h-full gap-x-2 p-2 rounded-md cursor-pointer', {
			'bg-black/[.02] hover:bg-black/4': gray,
		})}
		onClick={onClick}
		role={'button'}
	>
		<div className={'flex justify-center items-center w-6 h-6 bg-black/[.04] rounded-md'}>
			<Icon name={'plus'} />
		</div>
		<span>{children}</span>
	</div>
);

export default AddButton;
